<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading" >
    <mapfre-card [singleCard]="false" [additionalClasses]="'other-request fs-18 lh-24'">
        <ng-container>
            <form name="requestFormGroup" class="submit-question-form" [formGroup]="requestFormGroup"
                (ngSubmit)="sendRequest()" [ngClass]="'text-left ma-submit-question-form'">

                <div class="other-request-container">
                    <section class="send-request pb-3 border-bottom-1-9CB0BC mb-4">
                        <h2 class="title-copy brand-blue-secondary">{{ 'SEND_MESSAGE' | translate }}</h2>
                    </section>

                    <app-billing-header [policyTypeImg]="policyTypeImg" [policyType]="policyType"
                        [policyNumber]="policy?.policynumber.policyNumber" [policy]="policy">
                    </app-billing-header>

                    <section>
                        <div class="input margin-top mt16 mb-4 ng-select-main">
                                <div class="fs-16 mb-4">                                
                                <label for="select-topic" class="select-label mb-0">{{ 'SELECT_TOPIC' | translate
                                    }}</label>
                                    <ng-select
                                    class="other-request-dropdown" 
                                    [items]="topicOptions" 
                                    bindLabel="name" 
                                    autofocus 
                                    bindValue="name" 
                                    [searchable]="false" 
                                    [multiple]="false"
                                    [clearable]="false" 
                                    [markFirst]="false" 
                                    placeholder="Select one" 
                                    fixedPlaceholder="true"
                                    [formControlName]="'otherRequest_topic'"
                                    (change)="onMessageTopicChange()"> 
                                    </ng-select>
                            </div>
                                <div class="mb-4">
                                    <label for="select-topic" class="select-label mb-0">{{ 'ADD_ADDITIONAL_INFO_REQUIRED' | translate
                                        }}</label>
                                    <textarea formControlName="addInfo" [id]="'request-text'"
                                        [name]="'request-text'" placeholder="Type here" class="request-text"
                                        mdbInput></textarea>
                                </div>
                        </div>

                        <div class="row text-center">
                            <div class="col">
                                <mapfre-button [ngClass]="{'custom_loader':loading}"
                                    [additionalClasses]="'basic primary large-btn  mx-auto'" [disabledValue]="requestFormGroup.controls.otherRequest_topic.valid 
                                                    && requestFormGroup.controls.addInfo.valid" [inputType]="'submit'"
                                    [translateValue]="'SUBMIT' | translate"></mapfre-button>
                            </div>
                        </div>

                        <div class="row text-center mt-3">
                            <div class="col">
                                <mapfre-button [additionalClasses]="'ghost secondary large-btn mx-auto height-56'"
                                    [iconClasses]="'align-middle'"
                                    [routerLink]="['/my-insurance/'+ policy?.policynumber?.policyNumber +'/billing-request']">
                                    {{ 'BACK' | translate }}
                                </mapfre-button>
                            </div>
                        </div>
                    </section>
                </div>
            </form>
        </ng-container>
    </mapfre-card>
</ng-container>

<mapfre-modal [modalOptions]="sendRequestModal" [hideModal]='hideModal' 
    (closeModal)="resetHideModal($event)" *ngIf="showSuccessModal">
        <app-billing-comment (hideModalOutput)="resetHideModal($event)" [commentType]="requestType">
        </app-billing-comment>
</mapfre-modal>
<mapfre-modal [modalOptions]="sendRequestModal" [hideModal]='hideModal' 
    (closeModal)="resetHideModal($event)" *ngIf="showFailureModal">
        <app-request-unsuccess
            (isTryAgain)="tryAgain($event)">
        </app-request-unsuccess>
</mapfre-modal>